import { render, staticRenderFns } from "./review-flight.vue?vue&type=template&id=71055ece"
import script from "./review-flight.vue?vue&type=script&lang=js"
export * from "./review-flight.vue?vue&type=script&lang=js"
import style0 from "./review-flight.vue?vue&type=style&index=0&id=71055ece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports